/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateCvDataSchema = z.object({
	id: z.string(),
	fileName: z.string(),
	sizeInBytes: z.number(),
	uploadedAt: z.iso.datetime(),
})

export type CandidateCvDataSchema = z.infer<typeof candidateCvDataSchema>
